module.exports = __webpack_public_path__ + "static/media/stampd_full_white.80401e5f.png";